import { MONITORING_TASK_STATUS, MONITORING_TASK_STATUS_TITLE } from '@app/api/constants'

import type { LntSelectOption } from '@app/components/base/Select/types'

export const FILTERS_DYNAMIC_KEYS = {
  monitoringsKindFilter: 'monitoringsKindFilter',
  monitoringsTypeFilter: 'monitoringsTypeFilter',
  monitoringsSubtypesFilter: 'monitoringsSubtypesFilter',
  storesFilter: 'storesFilter',
  clustersFilter: 'clustersFilter',
  clusterGroupsFilter: 'clusterGroupsFilter',
  salesOrganizationFilter: 'salesOrganizationFilter',
  contractorsFilter: 'contractorsFilter',
  regionsFilter: 'regionsFilter',
  competitorsFilter: 'competitorsFilter',
  trendsFilter: 'trendsFilter',
  purchasingGroupsFilter: 'purchasingGroupsFilter',
  commodityGroupsFilter: 'commodityGroupsFilter',
  categoriesFilter: 'categoriesFilter',
  subcategoriesFilter: 'subcategoriesFilter',
  competitorsNetworksFilter: 'competitorsNetworksFilter',
  competitorsAddressesFilter: 'competitorsAddressesFilter',
  executorFilter: 'executorFilter',
  monitoringListsPromoFilter: 'monitoringListsPromoFilter'
} as const

export const FILTERS_STATIC_KEYS = {
  periodFilter: 'periodFilter',
  createdAtAfterFilter: 'createdAtAfterFilter',
  createdAtBeforeFilter: 'createdAtBeforeFilter',
  statusFilter: 'statusFilter',
  selectOption: 'selectOption',
  contractorCode: 'contractorCode',
  name: 'name',
  login: 'login',
  email: 'email',
  additionalInfo: 'additionalInfo',
  contacts: 'contacts',
  daysOfWeek: 'daysOfWeek',
  setTime: 'setTime',
  week: 'week',
  startPromoDateAt: 'startPromoDateAt',
  endPromoDateAt: 'endPromoDateAt',
  maxDiscount: 'maxDiscount',
  minDiscount: 'minDiscount',
  deadlineFrom: 'deadlineFrom',
  deadlineTo: 'deadlineTo',
  deadlineBefore: 'deadlineBefore',
  deadlineAfter: 'deadlineAfter',
  createdAtFrom: 'createdAtFrom',
  createdAtTo: 'createdAtTo',
  names: 'names',
  productCodeLenta: 'productCodeLenta', // TODO: пройтись по проекту и убрать "Lenta" из кода
  stopped: 'stopped',
  status: 'status',
  commentsByUsers: 'commentsByUsers',
  isConfirmed: 'isConfirmed',
  isMatchedWithProduct: 'isMatchedWithProduct',
  taskTypes: 'taskTypes',
  executor: 'executor',
  abnormalState: 'abnormalState',
  state: 'state'
} as const

export const FILTERS_PLACEHOLDERS = {
  [FILTERS_DYNAMIC_KEYS.monitoringsKindFilter]: 'Вид мониторинга',
  [FILTERS_DYNAMIC_KEYS.monitoringsTypeFilter]: 'Тип мониторинга',
  [FILTERS_DYNAMIC_KEYS.monitoringsSubtypesFilter]: 'Подтип мониторинга',
  [FILTERS_DYNAMIC_KEYS.storesFilter]: 'ТК Лента',
  [FILTERS_DYNAMIC_KEYS.clustersFilter]: 'Кластер',
  [FILTERS_DYNAMIC_KEYS.clusterGroupsFilter]: 'Группа кластеров',
  [FILTERS_DYNAMIC_KEYS.salesOrganizationFilter]: 'Сбытовая организация',
  [FILTERS_DYNAMIC_KEYS.contractorsFilter]: 'Подрядчик',
  [FILTERS_DYNAMIC_KEYS.regionsFilter]: 'Регион',
  [FILTERS_DYNAMIC_KEYS.trendsFilter]: 'Направление',
  [FILTERS_DYNAMIC_KEYS.purchasingGroupsFilter]: 'Группа закупок',
  [FILTERS_DYNAMIC_KEYS.commodityGroupsFilter]: 'Товарная группа',
  [FILTERS_DYNAMIC_KEYS.categoriesFilter]: 'Категория',
  [FILTERS_DYNAMIC_KEYS.subcategoriesFilter]: 'Подкатегория',
  [FILTERS_DYNAMIC_KEYS.competitorsNetworksFilter]: 'Сеть конкурента',
  [FILTERS_DYNAMIC_KEYS.competitorsAddressesFilter]: 'Адрес конкурента',
  [FILTERS_DYNAMIC_KEYS.executorFilter]: 'Исполнитель',
  [FILTERS_DYNAMIC_KEYS.monitoringListsPromoFilter]: 'Рекламное мероприятие',
  [FILTERS_STATIC_KEYS.periodFilter]: 'Период',
  [FILTERS_STATIC_KEYS.createdAtBeforeFilter]: 'Начальная дата',
  [FILTERS_STATIC_KEYS.createdAtAfterFilter]: 'Конечная дата',
  [FILTERS_STATIC_KEYS.selectOption]: 'Выберите параметр',
  [FILTERS_STATIC_KEYS.contractorCode]: 'Код подрядчика',
  [FILTERS_STATIC_KEYS.name]: 'Наименование',
  [FILTERS_STATIC_KEYS.login]: 'Логин',
  [FILTERS_STATIC_KEYS.email]: 'Электронная почта',
  [FILTERS_STATIC_KEYS.additionalInfo]: 'Дополнительные сведения',
  [FILTERS_STATIC_KEYS.contacts]: 'Контактная информация',
  [FILTERS_STATIC_KEYS.daysOfWeek]: 'День недели',
  [FILTERS_STATIC_KEYS.setTime]: 'Укажите время',
  [FILTERS_STATIC_KEYS.startPromoDateAt]: 'Дата начала промо',
  [FILTERS_STATIC_KEYS.endPromoDateAt]: 'Дата окончания промо',
  [FILTERS_STATIC_KEYS.maxDiscount]: 'Скидка от',
  [FILTERS_STATIC_KEYS.minDiscount]: 'Скидка до',
  [FILTERS_STATIC_KEYS.createdAtFrom]: 'Дата создания от',
  [FILTERS_STATIC_KEYS.createdAtTo]: 'Дата создания до',
  [FILTERS_STATIC_KEYS.deadlineFrom]: 'Дата исполнения от',
  [FILTERS_STATIC_KEYS.deadlineTo]: 'Дата исполнения до',
  [FILTERS_STATIC_KEYS.deadlineBefore]: 'Дедлайн, от',
  [FILTERS_STATIC_KEYS.deadlineAfter]: 'Дедлайн, до',
  [FILTERS_STATIC_KEYS.productCodeLenta]: 'Код товара Ленты',
  [FILTERS_STATIC_KEYS.commentsByUsers]: 'Комментарии',
  [FILTERS_STATIC_KEYS.isConfirmed]: 'Статус подтверждения',
  [FILTERS_STATIC_KEYS.isMatchedWithProduct]: 'Статус сопоставления',
  [FILTERS_STATIC_KEYS.taskTypes]: 'Тип задачи',
  [FILTERS_STATIC_KEYS.executor]: 'Исполнитель',
  [FILTERS_STATIC_KEYS.abnormalState]: 'Статус обработки',
  [FILTERS_STATIC_KEYS.state]: 'Статус передачи',
  productStatus: 'Статус товара',
  chosenWeek: 'Выберите неделю',
  zeroTime: '00:00',
  // TODO: вынести в динамические/статические ключи, как заработает на бэке
  // Сейчас не вынесены потому что используется на моканных фильтрах
  allPrices: 'Все цены',
  allPricesFrom: 'Все цены от',
  allPricesTo: 'Все цены до',
  productCode: 'Код продукта',
  productName: 'Наименование товара',
  productGroup: 'Группа Товара',
  comments: 'Комментарии',
  status: 'Статус',
  confirmedByLenta: 'Сопоставлен с товаром Ленты',
  manufacturer: 'Производитель',
  regionManufacturer: 'Страна произв.',
  brand: 'Бренд',
  categoryEggs: 'Категория яиц',
  shell: 'Оболочка',
  fatContentOrFortress: 'Жирность/крепость',
  productForm: 'Форма выпуска',
  packaging: 'Упаковка',
  volumeMl: 'Объем упаковки',
  volumeG: 'Объем упаковки',
  volumePieces: 'Объем упаковки',
  filterValue: 'Значение фильтра',
  comment: 'Напишите комментарий',
  samples: 'Выберите шаблон',
  hierarchyLevel: 'Уровень иерархии',
  value: 'Значение'
} as const

export const STATUS_FILTER_TITLES = {
  deleted: 'Удаленные',
  added: 'Добавленные',
  approved: 'Согласованные',
  changed: 'Измененные'
} as const

export const STATUS_PRODUCT = {
  confirmed: 'подтвержден',
  notConfirmed: 'не подтвержден'
}

export const PERIODS_VALUES = {
  week: 'week',
  date: 'date'
}

export const statusMonitoringTasksOptions: LntSelectOption[] = [
  { label: MONITORING_TASK_STATUS_TITLE.FORMING, value: MONITORING_TASK_STATUS.FORMING },
  { label: MONITORING_TASK_STATUS_TITLE.START, value: MONITORING_TASK_STATUS.START },
  { label: MONITORING_TASK_STATUS_TITLE.IN_PROGRESS, value: MONITORING_TASK_STATUS.IN_PROGRESS },
  { label: MONITORING_TASK_STATUS_TITLE.PROCESSING, value: MONITORING_TASK_STATUS.PROCESSING },
  { label: MONITORING_TASK_STATUS_TITLE.NEEDS_CORRECTION, value: MONITORING_TASK_STATUS.NEEDS_CORRECTION },
  { label: MONITORING_TASK_STATUS_TITLE.NEEDS_VERIFYING, value: MONITORING_TASK_STATUS.NEEDS_VERIFYING },
  { label: MONITORING_TASK_STATUS_TITLE.VERIFYING, value: MONITORING_TASK_STATUS.VERIFYING },
  { label: MONITORING_TASK_STATUS_TITLE.SENT_TO_BW, value: MONITORING_TASK_STATUS.SENT_TO_BW },
  { label: MONITORING_TASK_STATUS_TITLE.SEND_TO_BW_ERROR, value: MONITORING_TASK_STATUS.SEND_TO_BW_ERROR },
  { label: MONITORING_TASK_STATUS_TITLE.DONE, value: MONITORING_TASK_STATUS.DONE },
  { label: MONITORING_TASK_STATUS_TITLE.STOPPED, value: MONITORING_TASK_STATUS.STOPPED }
]
